import ctl from '@netlify/classnames-template-literals';

export const wrapperStyle = 'mt-6';

export const previewContainerStyle = ctl(`
  flex-center-between
  w-full
  space-x-2
`);
